module.exports = __webpack_public_path__ + "img/san-jose.aaa7e1fc.jpg";